import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import WhatThisMeans from "@/components/WhatThisMeans";
import ProcessOverview from "@/components/ProcessOverview";
import RJHTechnology from "@/components/RJHTechnology";
import RJHComparison from "@/components/RJHComparison";
import Services from "@/components/Services";
import Collaboration from "@/components/Collaboration";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminInquiries from "@/components/AdminInquiries";

function App() {
  const [showAdmin, setShowAdmin] = useState(false);

  // Check URL for admin access
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('admin') === 'true') {
      setShowAdmin(true);
    }
  }, []);

  if (showAdmin) {
    return (
      <div className="App">
        <AdminInquiries onBack={() => {
          setShowAdmin(false);
          window.history.pushState({}, '', '/');
        }} />
        <Toaster position="top-right" />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <WhatThisMeans />
        <ProcessOverview />
        <RJHTechnology />
        <RJHComparison />
        <Services />
        <Collaboration />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
